






































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import ajax from '@/lib/ajax';

@Component({})
export default class ProcessFinanceTransaction extends Vue {
  @Prop({ required: false }) orderId!: string;
  @Prop({ required: false }) orderNo!: string;
  @Prop({ required: false }) pendingType!: string;
  @Prop({ required: false }) pendingTotal!: number;
  @Prop({ default: false }) isEditMode!: boolean;
  @Prop({ required: false }) logId!: string;
  @Prop({ required: false }) transactionSubType!: string;
  @Prop({ required: false }) currentAmount!: number;
  @Prop({ required: false }) currentNote!: string;
  @Prop({ required: false }) currentDate!: string;

  dialog: boolean = true;
  dateMenu: boolean = false;
  transactionDate: string = moment().format('YYYY-MM-DD');
  amount: number = 0;
  note: string = '';
  loading: boolean = false;

  get formattedDate() {
    return this.transactionDate ? moment(this.transactionDate).format('DD-MM-YYYY') : '';
  }

  get getTitle() {
    if (this.isEditMode) {
      return 'İşlem Düzenle';
    }
    return this.pendingType === 'Refund' ? 'İade İşlemi' : 'Ek Ödeme İşlemi';
  }

  created() {
    if (this.isEditMode) {
      this.amount = this.currentAmount || 0;
      this.note = this.currentNote || '';
      this.transactionDate = this.currentDate ? moment(this.currentDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    } else {
      this.amount = this.pendingTotal || 0;
    }
  }

  async saveTransaction() {
    if (!this.amount || this.amount <= 0) {
      Vue.$toast.error('Lütfen geçerli bir tutar giriniz');
      return;
    }

    this.loading = true;
    try {
      if (this.isEditMode) {
        // Düzenleme modu - UpdateAgencyAccountLog
        const payload = {
          id: this.logId,
          amount: this.amount,
          transactionDate: this.transactionDate,
          note: this.note
        };
        await ajax.post('/api/services/app/Admin/UpdateAgencyAccountLog', payload);
        Vue.$toast.success('İşlem başarıyla güncellendi');
      } else {
        // Yeni işlem modu - ProcessFinanceTransaction
        const payload = {
          orderId: this.orderId,
          amount: this.amount,
          transactionType: this.pendingType === 'Refund' ? 0 : 1,
          note: this.note,
          transactionDate: this.transactionDate
        };
        await ajax.post('/api/services/app/Admin/ProcessFinanceTransaction', payload);
        Vue.$toast.success('İşlem başarıyla kaydedildi');
      }
      this.$emit('saved');
      this.closeDialog();
    } catch (error) {
      Vue.$toast.error('İşlem sırasında bir hata oluştu');
    } finally {
      this.loading = false;
    }
  }

  closeDialog() {
    this.$emit('closed');
  }
}
